
import { defineComponent, getCurrentInstance, ref } from 'vue';
import decice from '@/common/device-info';
import { checkIfKwaiProApp, checkIfAppEnvironment, checkIfIOSApp } from '@/common/app';
import { callFantasayAppFromKConfNew, OnelinkSceneKey } from '@/common/call-app';

const FantasyLogo = 'https://cdn-static.ap4r.com/kos/s101/nlav11312/kos/s101/nlav11312/pwa/mobile/aichat/new_fantasay_app_icon.png';
const AIOpenApp = defineComponent({
    components: {},
    props: {
        botID: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };
        const isShow = ref(!(checkIfAppEnvironment() && !checkIfKwaiProApp()) && !checkIfIOSApp());

        const handleClick = () => {
            const { isIOS } = decice();
            if (isIOS) {
                const storeLink = 'https://apps.apple.com/app/weeeye-novo-ia-chat/id6743759736';
                window.open(storeLink, '_blank');
                return;
            }
            callFantasayAppFromKConfNew({
                scene: OnelinkSceneKey.WebAiChatOpenAppPendant,
                proxy,
                customsParams: {
                    callAppPath: `botdetail/${props.botID}`,
                },
            });
        };

        function handleClose() {
            isShow.value = false;
        }

        return {
            isShow,
            FantasyLogo,
            handleClick,
            handleClose,
        };
    },
});

export default AIOpenApp;
